<template>
  <public-page>
    <div class="terms">
      <terms-conditions-card />
    </div>
  </public-page>
</template>

<script>
import PublicPage from './PublicPage'
import TermsConditionsCard from '../cards/TermsConditionsCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'terms',
  components: {
    PublicPage,
    TermsConditionsCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/terms-and-conditions',
      ogTitle: 'Terms and Conditions - Rewarding Dog Training',
      ogDescription: 'Rewarding Dog Training Terms and Conditions. Read me to get started with training!',
    })
  },
}
</script>

<style lang="scss">
.terms {
  margin-bottom: 6rem;
}
</style>
